import Vue from 'vue';
import Vuex from 'vuex';
import joiningPaymentStore from './calculators/joining-payment-store';
import waterPaymentStore from './calculators/water-payment-store';
Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        showOverlay: false,
        accordionOpen: null,
        pageNavigationBlockOpen: null,
        pageNavigationBlockPanelOpen: null
    },

    mutations: {
        hideOverlay(state) {
            state.showOverlay = false
        },
        showOverlay(state) {
            state.showOverlay = true
        },
        openAccordion(state, id) {
            state.accordionOpen = id;
        },
        closeAccordion(state, id) {
            state.accordionOpen = id;
        },
        scrollToView(state, target) {
            let anchor = document.getElementById(target);
            if (anchor) {
                var accordion = anchor.closest(".accordion");
                let scrollDuration = 0;
                if (accordion) {
                    scrollDuration = 1000;
                    this.commit("openAccordion", accordion.dataset.accordionId);
                }

                const scrollStepsIntervel = 500;
                var maxScrollStepsCount = scrollDuration / scrollStepsIntervel + 1;
                let scrollStepsCount = 0;
                const scrollIntoViewRun = () => {
                    scrollStepsCount++;
                    anchor.scrollIntoView({ behavior: 'smooth' });
                    if (maxScrollStepsCount > scrollStepsCount) {
                        setTimeout(scrollIntoViewRun, scrollStepsIntervel);
                    }
                };
                setTimeout(scrollIntoViewRun, 0);
            }
        },
        openPageNavigationBlock(state, id) {
            state.pageNavigationBlockOpen = id;
        },
        closePageNavigationBlock(state, id) {
            state.pageNavigationBlockOpen = id;
        },
        openPageNavigationBlockPanel(state, id) {
            state.pageNavigationBlockPanelOpen = id;
        },
        closePageNavigationBlockPanel(state, id) {
            state.pageNavigationBlockPanelOpen = id;
        }
    },
    modules: {
        joiningPaymentStore: joiningPaymentStore,
        waterPaymentStore: waterPaymentStore
    },
});